import {
    ActionReducerMap,
    createSelector,
    createFeatureSelector,
    ActionReducer,
    MetaReducer,
} from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';
import { environment } from '../../environments/environment';
import { RouterStateUrl } from '@clemos/jupiter/shared/utils';


/**
 * storeFreeze prevents state from being mutated. When mutation occurs, an
 * exception will be thrown. This is useful during development mode to
 * ensure that none of the reducers accidentally mutates the state.
 */
// import { storeFreeze } from 'ngrx-store-freeze';

/**
 * Every reducer module's default export is the reducer function itself. In
 * addition, each module should export a type or interface that describes
 * the state of the reducer plus any selector functions. The `* as`
 * notation packages up all of the exports into a single object.
 */

import * as fromRouter from '@ngrx/router-store';
import * as fromLayout from '@clemos/jupiter/core/reducers/layout.reducer';
import * as fromCurrentUser from '@clemos/jupiter/core/reducers/current-user.reducer';

//   import * as fromEnquiryReducer from '../enquiry/reducers/enquiry';
//   import * as fromInstitutionReducer from '../enquiry/reducers/institution';
//   import * as fromGeoReducer from '../enquiry/reducers/geo';


/**
 * As mentioned, we treat each reducer like a table in a database. This means
 * our top level state interface is just a map of keys to inner state types.
 */
export interface State {
    // enquiry: fromEnquiryReducer.State;
    // institution: fromInstitutionReducer.State;
    currentUser: fromCurrentUser.State;
    layout: fromLayout.State;
    router: fromRouter.RouterReducerState<RouterStateUrl>;
}

/**
 * Our state is composed of a map of action reducer functions.
 * These reducer functions are called with each dispatched action
 * and the current or initial state and return a new immutable state.
 */
export const reducers: ActionReducerMap<State> = {
    // enquiry: fromEnquiryReducer.reducer,
    // institution: fromInstitutionReducer.reducer,
    currentUser: fromCurrentUser.reducer,
    router: fromRouter.routerReducer,
    layout: fromLayout.reducer
};

// console.log all actions
export function logger(reducer: ActionReducer<State>): ActionReducer<State> {
    return function (state: State, action: any): State {
        console.log('state', state);
        console.log('action', action);

        return reducer(state, action);
    };
}

export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
    return localStorageSync({ keys: ['enquiry'], rehydrate: true })(reducer);
}

/**
 * By default, @ngrx/store uses combineReducers with the reducer map to compose
 * the root meta-reducer. To add more meta-reducers, provide an array of meta-reducers
 * that will be composed to form the root meta-reducer.
 */
export const metaReducers: MetaReducer<State>[] = !environment.production
    ? [localStorageSyncReducer, logger]
    : [localStorageSyncReducer];

// export const metaReducers: MetaReducer<State>[] = !environment.production
//   ? [logger]
//   : [];


/**
 * Layout Reducers
 */
export const getLayoutState = createFeatureSelector<fromLayout.State>('layout');

export const getShowSidenav = createSelector(
    getLayoutState,
    fromLayout.getShowSidenav
);

export const getShowAside = createSelector(
    getLayoutState,
    fromLayout.getShowAside
);

export const getShowQuickview = createSelector(
    getLayoutState,
    fromLayout.getShowQuickview
);

/**
 * Current User Reducers
 */

export const getCurrentUserState = createFeatureSelector<fromCurrentUser.State>('currentUser');

export const getCurrentUser = createSelector(
    getCurrentUserState,
    fromCurrentUser.getUser
);
